var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Bg2400(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2400,
    height: 820,
    viewBox: "0 0 2400 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M489.73 486.414H577.695V671.918H489.73V811.046H213.363V671.918H-98.958V515.823L258.54 10.2109H489.73V486.414Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.08 486.414H2501.04V671.918H2413.08V811.046H2136.71V671.918H1824.39V515.823L2181.89 10.2109H2413.08V486.414Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1702.48 197.407C1660.77 135.992 1598.21 87.7366 1514.8 52.642C1431.38 17.5473 1326.77 0 1200.96 0C1138.06 0 1080.29 4.72428 1027.64 14.1728C975.675 22.9465 928.84 36.107 887.132 53.6543C845.425 70.5267 808.845 91.1111 777.393 115.407C746.625 139.029 720.644 166.025 699.448 196.395C678.936 226.765 663.21 259.835 652.271 295.605C642.015 331.374 636.887 369.169 636.887 408.988C636.887 439.358 639.964 469.391 646.117 499.086C652.954 528.782 663.21 557.128 676.885 584.123C691.243 611.119 709.02 636.765 730.216 661.062C752.095 684.683 777.735 706.28 807.136 725.852C837.22 745.424 871.748 762.296 910.721 776.469C949.693 789.967 993.11 800.428 1040.97 807.852C1089.52 815.951 1142.85 820 1200.96 820C1282.33 820 1353.78 812.576 1415.31 797.728C1477.53 783.556 1530.86 763.646 1575.31 738C1619.75 711.679 1655.99 681.309 1684.02 646.889C1712.05 611.794 1732.56 574.337 1745.56 534.519C1758.55 494.025 1765.04 452.181 1765.04 408.988C1765.04 329.35 1744.19 258.823 1702.48 197.407Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Bg2400);
export default __webpack_public_path__ + "static/media/404Bg2400.5ff3ad6c226b823c75e7fc61b75f9eda.svg";
export { ForwardRef as ReactComponent };